import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyDJ7sxUAN8z49wfOcLESp2mYUnkpinQsBA",
  authDomain: "numberdarsolar-46ca0.firebaseapp.com",
  projectId: "numberdarsolar-46ca0",
  storageBucket: "numberdarsolar-46ca0.firebasestorage.app",
  messagingSenderId: "485343106201",
  appId: "1:485343106201:web:fe06c9a9098359008d5408",
  measurementId: "G-HYDJ8HB38M",
};

const firebaseApp = initializeApp(firebaseConfig);

export default firebaseApp;
